var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoadIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73852 14.8117C6.13734 16.3002 7.01616 17.6154 8.23867 18.5535C9.46118 19.4915 10.9591 20 12.5 20C14.0409 20 15.5388 19.4915 16.7613 18.5535C17.9838 17.6154 18.8627 16.3002 19.2615 14.8117",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13L11.8753 13.7809L12.5 14.2806L13.1247 13.7809L12.5 13ZM13.5 4C13.5 3.44772 13.0523 3 12.5 3C11.9477 3 11.5 3.44771 11.5 4L13.5 4ZM6.87531 9.78087L11.8753 13.7809L13.1247 12.2191L8.1247 8.21913L6.87531 9.78087ZM13.1247 13.7809L18.1247 9.78087L16.8753 8.21913L11.8753 12.2191L13.1247 13.7809ZM13.5 13L13.5 4L11.5 4L11.5 13L13.5 13Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoadIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/load-icon.fef26fe9f668e5112896bff433be555a.svg";